import { useTenant } from "@/hooks/useTenant"

interface ScopeLabelProps {
  /**
   * O escopo a mostrar ("all" ou o id), quando a tela usa um escopo diferente
   * do global (o Financeiro, que não mostra unidade sem o Financeiro). Sem ele,
   * o escopo do seletor do topo.
   */
  escopo?: string
  /**
   * O texto no lugar de "Todas as unidades", para a tela cujo "todas" é só uma
   * parte das unidades da pessoa (o Financeiro soma só as unidades em que está
   * ligado).
   */
  rotuloDeTodas?: string
}

/**
 * Displays the currently selected unit scope as a subtle subtitle.
 * Shows "Todas as unidades" when viewing all, or the specific tenant name.
 * Place directly below page titles for consistent scope indication.
 */
export function ScopeLabel({ escopo, rotuloDeTodas }: ScopeLabelProps = {}) {
  const { tenants, viewAll, selectedScope, activeTenantColor } = useTenant()

  if (tenants.length <= 1) return null

  const mostrado = escopo ?? (viewAll ? "all" : selectedScope)
  const unidade = mostrado === "all" ? undefined : tenants.find((t) => t.id === mostrado)
  const label = mostrado === "all" ? (rotuloDeTodas ?? "Todas as unidades") : (unidade?.name ?? "")
  const cor = escopo === undefined ? activeTenantColor : (unidade?.primary_color ?? null)

  return (
    <p
      className="text-xs font-medium mt-0.5"
      style={{ color: cor ?? "var(--text-tertiary)" }}
    >
      {label}
    </p>
  )
}
